//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const COLLECTION_SETTINGS_FILTERS = {
  BRAND_FEED_POST: 'brandFeedPost',
  BRAND_STORY_POST: 'brandStoryPost',
  ORIENTATION: 'orientations',
  MEDIA_TYPE: 'mediaTypes',
  RIGHTS_STATUS: 'rights',
  PRODUCT_TAGS: 'productTags',
  LABELS: 'labels',
  DISTRIBUTION: 'distribution',
  SOURCES_GROUPS: 'sourcesGroups',
  CURALATE_USER_IDS: 'curalateUserIds',
  TRACKED_BUSINESS_USER_IDS: 'trackedBusinessUserIds',
  TRACKED_USER_IDS: 'trackedUserIds',
  TRACKED_COMPETITOR_IDS: 'trackedCompetitorIds',
  TRACKED_HASHTAGS: 'trackedHashtags',
  ACCOUNT_MENTION_IDS: 'accountMentionIds',
  PINTEREST_USER_IDS: 'pinterestUserIds',
  DATE_RANGE: 'dateRange',
};
